import $ from "jquery";
import Chart from "chart.js";
$(document).ready(function () {
    if ($("#analytics-overview").length) {
        $.ajax({
            dataType: "json",
            url: dataset,
            data: params,
            success: function (data) {
                if (incomes == null || incomes == "null") {
                    var ctx = document.getElementById('myChart').getContext('2d');
                    var chart = new Chart(ctx, {
                        // The type of chart we want to create
                        type: 'bar',
                        // The data for our dataset
                        data: data.projects,
                        // Configuration options go here
                        options: {
                            title: {
                                display: true,
                                text: 'Factures envoyées'
                            },
                            tooltips: {
                                mode: 'index',
                                intersect: false
                            },
                            responsive: true,
                            scales: {
                                xAxes: [{
                                        stacked: true
                                    }],
                                yAxes: [{
                                        stacked: true
                                    }]
                            }
                        }
                    });
                }
                else {
                    var ctxClient = document.getElementById('clients').getContext('2d');
                    var clients = new Chart(ctxClient, {
                        // The type of chart we want to create
                        type: 'horizontalBar',
                        // The data for our dataset
                        data: data[incomes],
                        // Configuration options go here
                        options: {
                            tooltips: {
                                mode: 'index',
                                intersect: false
                            },
                            responsive: false,
                            // maintainAspectRatio: true,
                            scales: {
                                xAxes: [{
                                        stacked: true
                                    }],
                                yAxes: [{
                                        stacked: true
                                    }]
                            }
                        }
                    });
                }
            }
        });
    }
});
